import React, { Component } from "react";
import { connect } from "react-redux";
import VideoComponent from "./VideoComponent";
import { Col, Container, Row } from "reactstrap";
import userService from "../../services/userService";
import MPSBarLoader from "../MPSBarLoader";
import MPSButton from "../Buttons/Buttons/MPSButton";
import moment from "moment";
import {
  POLLING_DURATION_IN_SECONDS,
  POLLING_DURATION_INTERVAL_IN_MS,
} from "./Utils";
import CallWaitTimer from "./CallWaitTimer";
import PatientWebexMeeting from "./WebEx/Patient/PatientWebexMeeting";
import fileService from "../../services/fileService";

import I18nProvider from "../../services/I18nProvider";
import Text from "../../components/Text";
import Messages from "../../Shared/Messages";

const intl = I18nProvider.getIntlProvider();

const ERROR =
  "Unable to join the video call. May be the call is not scheduled yet. Please contact your health care provider.";
const PARTICIPANT_ERROR =
  "Other person has not joined the call. Please try again later";

function getOtherParticipantName(participants) {
  let filtered = participants.filter((p) => p.referenceType !== "PATIENT");
  if (filtered && filtered[0]) {
    return filtered[0].displayHumanName.text;
  }
  return "Care Provider";
}

class AnonymousVideoCallContainer extends Component {
  constructor(props) {
    super();
    this.state = {
      logoImg: null,
      logoLoading: true
    };
  }
  
  componentDidMount() {
    console.log("[ANONYMOUS VIDEO] Component mounted, getting logo...");
    this.getLogoImg();
  }
  
  getLogoImg = () => {
    console.log("[ANONYMOUS VIDEO] Props:", this.props);
    console.log("[ANONYMOUS VIDEO] AppTheme:", this.props.appTheme);
    
    const { hospitalLogoImage } = this.props.appTheme || {};
    console.log("[ANONYMOUS VIDEO] hospitalLogoImage:", hospitalLogoImage);
    
    if (hospitalLogoImage) {
      console.log("[ANONYMOUS VIDEO] hospitalLogoImage.contentURL:", hospitalLogoImage.contentURL);
      
      fileService
        .getFile(hospitalLogoImage.contentURL)
        .then(logoImg => {
          console.log("[ANONYMOUS VIDEO] Logo loaded successfully:", logoImg);
          this.setState({ logoImg, logoLoading: false });
        })
        .catch(e => {
          console.error("[ANONYMOUS VIDEO] Failed to load facility logo:", e);
          console.log("[ANONYMOUS VIDEO] Using default MPS logo");
          this.setState({ logoImg: null, logoLoading: false });
        });
    } else {
      console.log("[ANONYMOUS VIDEO] No hospitalLogoImage found in appTheme, using default");
      this.setState({ logoLoading: false });
    }
  };

  onStartAnonymousCall = (e) => {
    let { roomName } = this.props;
    this.setState({ loading: true });
    this.pollingStart = moment();
    this.doPollingToJoinCall(roomName);
  };

  doPollingToJoinCall = (roomName) => {
    userService
      .joinVideoRoom(roomName)
      .then((response) => {
        let {
          roomName,
          jwt: token,
          participants,
          provider,
          roomNameAndUserId,
        } = response;
        if (provider === "WEBEX") {
          this.setState({
            callNotReady: false,
            provider,
            roomName, //sipAddress
            participants,
            loading: false,
            roomNameAndUserId,
          });
        } else {
          if (token) {
            this.setState({
              callNotReady: false,
              token,
              roomName,
              participants,
              loading: false,
            });
          } else {
            this.setState({ callNotReady: true, loading: false, participants });
            setTimeout(() => {
              let diff = moment().diff(this.pollingStart, "second");
              if (diff <= POLLING_DURATION_IN_SECONDS) {
                this.doPollingToJoinCall(roomName);
              } else {
                this.setState({ error: PARTICIPANT_ERROR });
              }
            }, POLLING_DURATION_INTERVAL_IN_MS);
          }
        }
      })
      .catch(this.handleError);
  };

  handleError = (error) => {
    this.setState({
      loading: false,
      error: error.message || ERROR,
    });
  };

  getView = () => {
    let {
      loading,
      token,
      error,
      roomName,
      participants,
      callNotReady,
      provider,
      roomNameAndUserId,
    } = this.state;

    if (loading) {
      return (
        <div className="loading-container">
          <div className="loading-content">
            <div className="pulse-ring"></div>
            <MPSBarLoader />
            <p className="loading-text">Connecting to your call...</p>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="error-container">
          <div className="error-content">
            <div className="error-icon">
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="#ef4444"
                  strokeWidth="2"
                />
                <line
                  x1="15"
                  y1="9"
                  x2="9"
                  y2="15"
                  stroke="#ef4444"
                  strokeWidth="2"
                />
                <line
                  x1="9"
                  y1="9"
                  x2="15"
                  y2="15"
                  stroke="#ef4444"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <h3 className="error-title">Connection Failed</h3>
            <p className="error-message">{error}</p>
            <button
              className="retry-button"
              onClick={() => this.setState({ error: null })}
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    if (callNotReady) {
      return (
        <div className="waiting-container">
          <div className="waiting-content">
            <div className="waiting-animation">
              <div className="waiting-dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>
            <h3 className="waiting-title">Waiting for Connection</h3>
            <p className="waiting-message">
              Call with{" "}
              <span className="participant-name">
                {getOtherParticipantName(participants)}
              </span>
              , waiting for them to join.
            </p>
            <div className="timer-container">
              <CallWaitTimer />
            </div>
          </div>
        </div>
      );
    }

    if (provider === "WEBEX") {
      return (
        <PatientWebexMeeting
          sipAddress={roomName}
          roomNameAndUserId={roomNameAndUserId}
        />
      );
    }

    if (token) {
      return (
        <VideoComponent
          token={token}
          roomName={roomName}
          participants={participants}
          otherParticipantName={getOtherParticipantName(participants)}
          existing={true}
        />
      );
    }

    return (
      <div className="video-call-landing">
        <div className="header-logo">
          {console.log("[ANONYMOUS VIDEO] Rendering logo, logoImg:", this.state.logoImg, "logoLoading:", this.state.logoLoading)}
          <img 
            alt="myPatientSpace" 
            src={this.state.logoImg || "/img/mps-logo.png"} 
            height={40} 
            onError={(e) => {
              console.error("[ANONYMOUS VIDEO] Image failed to load:", e.target.src);
              e.target.src = "/img/mps-logo.png";
            }}
          />
        </div>

        <div className="main-content">
          <div className="welcome-section">
            <div className="video-icon">
              <svg
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M23 7L16 12L23 17V7Z" fill="url(#gradient1)" />
                <rect
                  x="1"
                  y="5"
                  width="15"
                  height="14"
                  rx="2"
                  fill="url(#gradient2)"
                />
                <defs>
                  <linearGradient
                    id="gradient1"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#3b82f6" />
                    <stop offset="100%" stopColor="#1d4ed8" />
                  </linearGradient>
                  <linearGradient
                    id="gradient2"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#60a5fa" />
                    <stop offset="100%" stopColor="#3b82f6" />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            <h1 className="welcome-title">
              <Text content={Messages.video_call_title} />
            </h1>

            <p className="welcome-subtitle">
              Connect with your healthcare provider
            </p>
          </div>

          <div className="join-section">
            <MPSButton
              className="join-button"
              size="lg"
              onClick={this.onStartAnonymousCall}
            >
              <div className="button-content">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 14H20.5L22 15.5V6.5L20.5 5H3.5L2 6.5V15.5L3.5 17H9.5L15.5 14Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path d="M11 8.5V11.5L13 10L11 8.5Z" fill="currentColor" />
                </svg>
                <Text content={Messages.join_video_call} />
              </div>
            </MPSButton>
          </div>

          <div className="troubleshooting-section">
            <details className="troubleshooting-toggle">
              <summary className="troubleshooting-header">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M9.09 9A3 3 0 0 1 12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <line
                    x1="12"
                    y1="17"
                    x2="12.01"
                    y2="17"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                </svg>
                Need help connecting?
              </summary>
              <div className="troubleshooting-content">
                <div className="troubleshooting-tips">
                  <div className="tip-item">
                    <div className="tip-icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 1V3M12 21V23M4.22 4.22L5.64 5.64M18.36 18.36L19.78 19.78M1 12H3M21 12H23M4.22 19.78L5.64 18.36M18.36 5.64L19.78 4.22"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                    <div>
                      <h5>Camera and Microphone</h5>
                      <p>
                        Make sure your browser has permission to access your
                        camera and microphone.
                      </p>
                    </div>
                  </div>

                  <div className="tip-item">
                    <div className="tip-icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 6V22L8 18H21V2H1V6Z"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                    <div>
                      <h5>Browser Compatibility</h5>
                      <p>
                        For best results, use Chrome, Firefox, Safari, or Edge.
                        Avoid older browser versions.
                      </p>
                    </div>
                  </div>

                  <div className="tip-item">
                    <div className="tip-icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 3L5 7L9 3M15 21L19 17L23 21M2 12H22"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                    <div>
                      <h5>Connection Issues</h5>
                      <p>
                        Check your internet connection and try refreshing the
                        page if the call doesn't connect.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </details>
          </div>
        </div>

        <style jsx>{`
          .video-call-landing {
            min-height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 2rem;
            position: relative;
            overflow: hidden;
          }

          .video-call-landing::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.05"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.05"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.03"/><circle cx="10" cy="60" r="0.5" fill="white" opacity="0.03"/><circle cx="90" cy="40" r="0.5" fill="white" opacity="0.03"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
          }

          .header-logo {
            position: absolute;
            top: 2rem;
            left: 2rem;
            z-index: 10;
            opacity: 0;
            animation: fadeInDown 0.8s ease-out 0.2s forwards;
          }

          .main-content {
            max-width: 800px;
            width: 100%;
            text-align: center;
            z-index: 2;
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 0.4s forwards;
          }

          .welcome-section {
            margin-bottom: 3rem;
          }

          .video-icon {
            margin-bottom: 2rem;
            opacity: 0;
            animation: scaleIn 0.6s ease-out 0.6s forwards;
          }

          .welcome-title {
            font-size: 3rem;
            font-weight: 700;
            color: white;
            margin-bottom: 1rem;
            letter-spacing: -0.02em;
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 0.8s forwards;
          }

          .welcome-subtitle {
            font-size: 1.25rem;
            color: rgba(255, 255, 255, 0.8);
            margin-bottom: 0;
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 1s forwards;
          }

          .join-section {
            margin-bottom: 4rem;
          }

          .join-button {
            background: linear-gradient(
              135deg,
              #10b981 0%,
              #059669 100%
            ) !important;
            border: none !important;
            border-radius: 16px !important;
            padding: 1rem 3rem !important;
            font-size: 1.25rem !important;
            font-weight: 600 !important;
            color: white !important;
            box-shadow: 0 20px 40px rgba(16, 185, 129, 0.3) !important;
            transition: all 0.3s ease !important;
            margin-bottom: 1.5rem;
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 1.2s forwards;
          }

          .join-button:hover {
            transform: translateY(-2px) !important;
            box-shadow: 0 25px 50px rgba(16, 185, 129, 0.4) !important;
            background: linear-gradient(
              135deg,
              #059669 0%,
              #047857 100%
            ) !important;
          }

          .join-button:active {
            transform: translateY(0) !important;
          }

          .button-content {
            display: flex;
            align-items: center;
            gap: 0.75rem;
          }

          .security-info {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            color: rgba(255, 255, 255, 0.8);
            font-size: 0.9rem;
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 1.4s forwards;
          }

          .troubleshooting-section {
            margin-top: 2rem;
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 1.6s forwards;
          }

          .troubleshooting-toggle {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border-radius: 12px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            overflow: hidden;
          }

          .troubleshooting-header {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 1rem 1.5rem;
            color: rgba(255, 255, 255, 0.9);
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            list-style: none;
          }

          .troubleshooting-header:hover {
            background: rgba(255, 255, 255, 0.05);
            color: white;
          }

          .troubleshooting-header::-webkit-details-marker {
            display: none;
          }

          .troubleshooting-content {
            padding: 0 1.5rem 1.5rem;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
          }

          .troubleshooting-tips {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            margin-top: 1rem;
          }

          .tip-item {
            display: flex;
            align-items: flex-start;
            gap: 1rem;
            padding: 1rem;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 8px;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }

          .tip-icon {
            color: #10b981;
            flex-shrink: 0;
            margin-top: 0.25rem;
          }

          .tip-item h5 {
            color: white;
            font-size: 0.95rem;
            font-weight: 600;
            margin-bottom: 0.25rem;
          }

          .tip-item p {
            color: rgba(255, 255, 255, 0.7);
            font-size: 0.85rem;
            margin: 0;
            line-height: 1.4;
          }

          .features-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 2rem;
            opacity: 0;
            animation: fadeInUp 0.8s ease-out 1.6s forwards;
          }

          .feature-item {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border-radius: 16px;
            padding: 2rem;
            text-align: center;
            border: 1px solid rgba(255, 255, 255, 0.2);
            transition: all 0.3s ease;
          }

          .feature-item:hover {
            transform: translateY(-5px);
            background: rgba(255, 255, 255, 0.15);
          }

          .feature-icon {
            color: #10b981;
            margin-bottom: 1rem;
          }

          .feature-item h4 {
            color: white;
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
          }

          .feature-item p {
            color: rgba(255, 255, 255, 0.7);
            font-size: 0.9rem;
            margin: 0;
          }

          .loading-container {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 60vh;
          }

          .loading-content {
            text-align: center;
            position: relative;
          }

          .pulse-ring {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 120px;
            height: 120px;
            border: 3px solid rgba(16, 185, 129, 0.3);
            border-radius: 50%;
            animation: pulse 2s infinite;
          }

          .loading-text {
            color: #374151;
            font-size: 1.1rem;
            margin-top: 2rem;
          }

          .error-container {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 60vh;
          }

          .error-content {
            text-align: center;
            max-width: 400px;
            padding: 2rem;
            background: white;
            border-radius: 16px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          }

          .error-icon {
            margin-bottom: 1.5rem;
          }

          .error-title {
            color: #ef4444;
            font-size: 1.5rem;
            font-weight: 600;
            margin-bottom: 1rem;
          }

          .error-message {
            color: #6b7280;
            margin-bottom: 2rem;
            line-height: 1.5;
          }

          .retry-button {
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            color: white;
            border: none;
            border-radius: 8px;
            padding: 0.75rem 2rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .retry-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(59, 130, 246, 0.3);
          }

          .waiting-container {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 60vh;
          }

          .waiting-content {
            text-align: center;
            max-width: 500px;
            padding: 3rem;
            background: white;
            border-radius: 20px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          }

          .waiting-animation {
            margin-bottom: 2rem;
          }

          .waiting-dots {
            display: flex;
            justify-content: center;
            gap: 0.5rem;
          }

          .dot {
            width: 12px;
            height: 12px;
            background: #10b981;
            border-radius: 50%;
            animation: bounce 1.4s infinite ease-in-out both;
          }

          .dot:nth-child(1) {
            animation-delay: -0.32s;
          }
          .dot:nth-child(2) {
            animation-delay: -0.16s;
          }

          .waiting-title {
            color: #374151;
            font-size: 1.5rem;
            font-weight: 600;
            margin-bottom: 1rem;
          }

          .waiting-message {
            color: #6b7280;
            font-size: 1.1rem;
            margin-bottom: 2rem;
          }

          .participant-name {
            color: #10b981;
            font-weight: 600;
          }

          .timer-container {
            background: #f3f4f6;
            padding: 1rem;
            border-radius: 12px;
            display: inline-block;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes scaleIn {
            from {
              opacity: 0;
              transform: scale(0.8);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes pulse {
            0% {
              transform: translate(-50%, -50%) scale(0.8);
              opacity: 1;
            }
            100% {
              transform: translate(-50%, -50%) scale(1.2);
              opacity: 0;
            }
          }

          @keyframes bounce {
            0%,
            80%,
            100% {
              transform: scale(0);
            }
            40% {
              transform: scale(1);
            }
          }

          @media (max-width: 768px) {
            .video-call-landing {
              padding: 1rem;
            }

            .welcome-title {
              font-size: 2rem;
            }

            .welcome-subtitle {
              font-size: 1rem;
            }

            .features-grid {
              grid-template-columns: 1fr;
              gap: 1rem;
            }

            .feature-item {
              padding: 1.5rem;
            }

            .header-logo {
              top: 1rem;
              left: 1rem;
            }
          }
        `}</style>
      </div>
    );
  };

  render() {
    return (
      <div className="app flex-column justify-content-center align-items-center">
        <Container fluid={true}>
          <Row className="justify-content-center">
            <Col md="12" sm={12}>
              {this.getView()}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapstatetoprops = (state, ownProps) => {
  return {
    roomName:
      ownProps.match && ownProps.match.params && ownProps.match.params.roomName
        ? ownProps.match.params.roomName
        : null,
    appTheme: state.user.data ? state.user.data.appTheme : {}
  };
};

export default connect(mapstatetoprops)(AnonymousVideoCallContainer);
